module.exports = "<ngx-toasta [position]=\"'top-right'\"></ngx-toasta>\n<router-outlet><app-spinner></app-spinner></router-outlet>"